import { Outlet, useNavigation, useParams } from 'react-router';

import useSessionPlQuery from '~/hooks/queries/useSessionPlQuery';
import { isPendingAccountSwitch } from '~/routing/isPendingAccountSwitch';

/**
 * Holds the account outlet until session matches the URL account.
 * While switching accounts, unmounts the outlet so account pages do not
 * render against the previous session. Layout session observers are paused
 * via `useSessionPlQuery` + `isPendingAccountSwitch` for the same window.
 */
export default function SessionHandler() {
  const { accountId, accountType } = useParams();
  const navigation = useNavigation();

  const isSwitchingAccount = isPendingAccountSwitch({
    navigationState: navigation.state,
    currentAccountId: accountId,
    currentAccountType: accountType,
    nextPathname: navigation.location?.pathname,
  });

  const sessionPlQuery = useSessionPlQuery();

  const sessionMatches =
    !isSwitchingAccount &&
    sessionPlQuery.data?.id.toString() === accountId &&
    sessionPlQuery.data?.accountType === accountType;

  return sessionMatches ? <Outlet /> : null;
}
